import { c as _c } from "react/compiler-runtime";
import { IcoCloseSmall16 } from '@onefootprint/icons';
import { IconButton, InlineAlert, type InlineAlertVariant } from '@onefootprint/ui';
import { AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useStore } from './hooks/use-store';
type DismissableBannerProps = {
  /** A unique identifier for this DismissableBanner. */
  component: string;
  variant?: InlineAlertVariant;
  children: React.ReactNode;
  /** For testing. When true, shows the dialog even if it has already been dismissed. */
  forceShow?: boolean;
};
const DismissableBanner = t0 => {
  const $ = _c(8);
  const {
    component,
    children,
    forceShow,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "neutral" : t1;
  const {
    t
  } = useTranslation("common");
  const {
    dismiss,
    isDismissed
  } = useStore(component, forceShow);
  let t2;
  if ($[0] !== children || $[1] !== dismiss || $[2] !== isDismissed || $[3] !== t || $[4] !== variant) {
    t2 = isDismissed ? null : <div className="relative"><InlineAlert variant={variant}>{children}<div className="absolute right-1 top-1"><IconButton aria-label={t(_temp)} onClick={dismiss} size="compact" icon={IcoCloseSmall16} /></div></InlineAlert></div>;
    $[0] = children;
    $[1] = dismiss;
    $[2] = isDismissed;
    $[3] = t;
    $[4] = variant;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <AnimatePresence>{t2}</AnimatePresence>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default DismissableBanner;
function _temp($) {
  return $.dismiss;
}